import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Form, Formik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import InputField from "../../common/InputField";

import { updateVdsProfile } from "../../services/user/UserServices";
import {
  initialValues as PortfolioInitialValues,
  validate,
} from "../../constants/portfolio";
import { PrimaryButton } from "../../common/Buttons";

import "../portfolio/portfolio.scss";
import { useTranslation } from "react-i18next";
import PhoneFieldWrapper from "../../common/phoneFieldWrapper/PhoneFieldWrapper";
import { EG_CONSULTANT } from "../../constants/constants";
const UserDataForm = ({ data, next, handleMfaTokenId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState(PortfolioInitialValues);

  useEffect(() => {
    data &&
      setInitialValues({
        ...PortfolioInitialValues,
        ...data,
        phoneNumber: data?.phoneNumber === null ? "+49" : data?.phoneNumber,
        dateOfBirth: data.dateOfBirth.slice(0, 10),
        futureCarePermissions: true,
        futureCareTermsOfUse: true,
      });
  }, [data]);

  const trackChangeForPhoneInput = (input) => {
    const { phoneNumber: phoneNumberFromData } = data;
    return input === phoneNumberFromData;
  };

  const handleSubmit = async (values) => {
    const { phoneNumber: phoneNumberFromValues } = values;
    const result = await updateVdsProfile(values);
    if (
      data?.role?.roleName === EG_CONSULTANT ||
      (result?.success &&
        data?.phoneNumberConfirmed &&
        trackChangeForPhoneInput(phoneNumberFromValues))
    ) {
      navigate("/");
    } else if (result?.success) {
      handleMfaTokenId(result?.payLoad?.mfaTokenId);
      next();
    } else {
      toast.error(result?.message);
    }
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className="portfolio-page"
    >
      <Grid
        container
        direction="column"
        marginTop="3rem"
        padding="1rem"
        width="30%"
        className="main-div"
      >
        <>
          <Toaster />
          {/* <Typography variant="p" color="color.magentaDark1" fontSize="22px">
            {t("step")} 1 {t('from')} 2
          </Typography> */}
          <br />
          <Typography variant="h4" fontWeight="bold" color="color.magentaDark1">
            {t("user-data")}
          </Typography>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate(t)}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="John"
                  label={t("input-1")}
                  name="firstName"
                  type="text"
                />
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="Doe"
                  label={t("input-10")}
                  name="lastName"
                  type="text"
                />
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="Doe"
                  autocomplete="off"
                  label={t("input-3")}
                  name="email"
                  type="email"
                  className="custom-disable"
                  InputLabelProps={{ shrink: true }}
                />

                <InputField
                  fullWidth
                  dateFormatProp={"DD MM YYYY"}
                  variant="standard"
                  label={t("input-2")}
                  name="dateOfBirth"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  onKeyDown={handleDateOfBirthKeyDown}
                />

                <FormControl
                  variant="standard"
                  margin="dense"
                  fullWidth
                  className="disabled-select"
                >
                  <InputLabel id="demo-simple-select-standard-label">
                    {t("input-21")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    name="gender"
                    onChange={(event) => {
                      formik.setFieldValue("gender", event.target.value);
                    }}
                    label={t("age")}
                    value={formik.values.gender}
                    disabled={formik.values.gender ? true : false}
                  >
                    <MenuItem value={"male"}>{t("male")}</MenuItem>
                    <MenuItem value={"female"}>{t("female")}</MenuItem>
                    <MenuItem value={"other"}>{t("rm-type-7")}</MenuItem>
                  </Select>
                  <p style={{ margin: 0, fontSize: "12px", color: "red" }}>
                    {formik.errors.gender}
                  </p>
                </FormControl>
                <Grid container spacing={2}>
                  <Grid item lg={7} md={6} xs={12}>
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder={t("street-placeholder")}
                      label={t("input-6")}
                      name="street"
                      type="text"
                    />
                  </Grid>
                  <Grid item lg={5} md={6} xs={12}>
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="40023"
                      label={t("input-7")}
                      name="houseNumber"
                      type="text"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item lg={7} md={6} xs={12}>
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="New york"
                      label={t("input-8")}
                      name="city"
                      type="text"
                    />
                  </Grid>
                  <Grid item lg={5} md={6} xs={12}>
                    <InputField
                      fullWidth
                      variant="standard"
                      label={t("input-9")}
                      name="postalCode"
                      type="number"
                    />
                  </Grid>
                </Grid>
                <InputLabel
                  id="demo-simple-select-standard-label"
                  className="phone-number-field"
                >
                  {t("input-24")}
                </InputLabel>
                <PhoneFieldWrapper name="phoneNumber" formik={formik} />
                <Grid
                  container
                  spacing={2}
                  marginTop="1rem"
                  className="form-buttons"
                >
                  <Grid item lg={6} width="50%">
                    <PrimaryButton
                      width="100%"
                      title={t("save")}
                      fullWidth={true}
                      textTransform="capitalize"
                      click={formik.handleSubmit}
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </>
      </Grid>
    </Grid>
  );
};

export default UserDataForm;
